import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute left-2 flex size-4 items-center justify-center" }

import { computed, type HTMLAttributes } from 'vue';
import { SelectItem, SelectItemText, SelectItemIndicator, type SelectItemProps } from 'reka-ui';
import { Check } from '@lucide/vue';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectItem',
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props;
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectItem), _mergeProps(forwarded.value, {
    class: 
      _unref(cn)(
        'relative flex w-full cursor-default select-none items-center rounded-md py-2 pl-8 pr-3 text-sm outline-none data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        props.class
      )
    
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(SelectItemIndicator), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Check), { class: "size-4" })
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(SelectItemText), null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})